import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    ref: "dateDialog",
    modelValue: _ctx.dateDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateDialog) = $event)),
    "return-value": _ctx.dateRange,
    persistent: "",
    title: "",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close())),
    width: "550px"
  }, {
    activator: _withCtx(({ props }) => [
      (!_ctx.hideActivator)
        ? (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
            key: 0,
            label: _ctx.label,
            "prepend-inner-icon": "$oss-calendar",
            readonly: "",
            outlined: "",
            "hide-details": _ctx.hideDetails,
            "data-cy": _ctx.prefixDataCy + '-date',
            class: _ctx.fullTextFieldClass,
            modelValue: _ctx.formatDateRange,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formatDateRange) = $event)),
            density: "compact"
          }, props), null, 16, ["label", "hide-details", "data-cy", "class", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_v_btn_primary, {
        block: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valid())),
        "data-cy": _ctx.prefixDataCy + '-date-ok',
        size: "large"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Valider")
        ])),
        _: 1
      }, 8, ["data-cy"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_date_picker_wrapper, {
                modelValue: _ctx.dateRange,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateRange) = $event)),
                "first-day-of-week": 1,
                multiple: "range",
                scrollable: "",
                "hide-header": "",
                type: _ctx.type,
                disabled: _ctx.disabled,
                "allowed-dates": _ctx.allowedDates,
                "data-cy": _ctx.prefixDataCy + '-calendar'
              }, null, 8, ["modelValue", "type", "disabled", "allowed-dates", "data-cy"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "return-value"]))
}